import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Typography, AppBar, Tabs, Tab, Fade } from "@mui/material";
import ManualSearch from "./ManualSearch";
import VehicleIdentification from "./VehicleIdentification";
import RecentSearch from "./RecentSearch";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`compact-vehicle-tabpanel-${index}`}
      aria-labelledby={`compact-vehicle-tab-${index}`}
      style={{
        flex: value === index ? 1 : undefined,
        display: value === index ? "flex" : "none",
        flexDirection: "column",
        background: "#f1f1f1",
        padding: "0px 8px",
        minHeight: 0,
      }}
      {...other}
    >
      <Fade in={value === index}>
        <Box
          sx={{
            p: 0.5,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      </Fade>
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `compact-vehicle-tab-${index}`,
    "aria-controls": `compact-vehicle-tabpanel-${index}`,
  };
}

/** Compact Manual / Vehicle ID / Recent tabs for the home lower-left card. */
const CompactCarModelSearch = () => {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
      }}
    >
      <AppBar position="static" style={{ boxShadow: "none" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="vehicle search tabs"
        >
          <Tab
            icon={
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/manual_search_car.svg"
                  alt="Manual search"
                  style={{ width: "20px", marginRight: "4px" }}
                />
                <Typography
                  sx={{
                    display: { xs: "none", sm: "block" },
                    color: "#fff",
                    fontSize: "11px",
                    fontFamily: "Inter",
                    textTransform: "capitalize",
                  }}
                >
                  Manual
                </Typography>
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            icon={
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/search_white_car.svg"
                  alt="Vehicle identification"
                  style={{ width: "20px", marginRight: "4px" }}
                />
                <Typography
                  sx={{
                    display: { xs: "none", sm: "block" },
                    color: "#fff",
                    fontSize: "11px",
                    fontFamily: "Inter",
                    textTransform: "capitalize",
                  }}
                >
                  Vehicle ID
                </Typography>
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            icon={
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/recent_icon.svg"
                  alt="Recent search"
                  style={{ width: "20px", marginRight: "4px" }}
                />
                <Typography
                  sx={{
                    display: { xs: "none", sm: "block" },
                    color: "#fff",
                    fontSize: "11px",
                    fontFamily: "Inter",
                    textTransform: "capitalize",
                  }}
                >
                  Recent
                </Typography>
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>
      <Box sx={{ background: "#f1f1f1", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <ManualSearch />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <VehicleIdentification />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <RecentSearch />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default CompactCarModelSearch;
